import React from 'react';
import { Box, Typography, TextField } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const AddNewProduct = ({ form, update }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Product Information
      </Typography>

      <TextField
        label="Product Name"
        variant="outlined"
        fullWidth
        margin="normal"
        required
        value={form.name}
        onChange={(e) => update('name', e.target.value)}
      />

      <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }} color="text.secondary">
        Product Description
      </Typography>
      <ReactQuill
        theme="snow"
        value={form.description}
        onChange={(value) => update('description', value)}
      />
    </Box>
  );
};

export default AddNewProduct;
